export default "__VITE_ASSET__DQ69JhWQ__"